import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useLocation } from "react-router-dom";

// Styled components for the breadcrumb container and items
const BreadcrumbContainer = styled.nav`
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #333;
    width: fit-content;
    height: 100%;

    @media (max-width: 767px) {
        font-size: 12px;
    }
`;

const Crumb = styled.a`
    text-decoration: none;
    color: ${(props) => (props.active ? "#555" : "#000")};
    font-weight: ${(props) => (props.active ? "bold" : "normal")};
    cursor: ${(props) => (props.active ? "default" : "pointer")};

    &:last-child {
        display: -webkit-box;
        -webkit-line-clamp: 1; /* Truncate to a single line */
        -webkit-box-orient: vertical;
        overflow: hidden;
        white-space: normal;

        /* Adjust width for truncation to 4-5 words */
        width: 250px; /* Desktop width */
    }

    /* Tablet viewport adjustments */
    @media (min-width: 768px) and (max-width: 991px) {
        &:last-child {
            width: 200px; /* Adjust for tablets */
        }
    }

    /* Mobile viewport adjustments */
    @media (max-width: 767px) {
        &:last-child {
            width: 100px; /* Adjust for small screens */
        }
    }


    &:hover {
        color: ${(props) => (props.active ? "#555" : "#000")};
    }
`;

const Separator = styled.span`
    margin: 0 8px;
    color: #999;
`;

export default function Breadcrumb() {
    const location = useLocation();
    const [breadcrumbs, setBreadcrumbs] = useState([]);

    useEffect(() => {
        const pathSegments = location.pathname.split("/").filter(Boolean);

        // Mapping for known segments
        const pathMap = {
            typology: "By Typology",
            byYear: "By Year",
            byLocation: "By Location",
            byScale: "By Scale",
            events: "Events",
            writings: "Writings",
            space: "Space",
            context: "Context",
            urban: "Urban",
            rural: "Rural",
            material: "Material",
            publicLectures: "Public Lectures",
            classLecture: "Class Lectures",
            conversations: "Conversations",
            podcasts: "Podcasts",
            pastEvent: "Past Event",
            upcomingEvent: "Upcoming Event",
            liveShow: "Live Show",
            contact: "Contact",
        };

        const crumbs = pathSegments.map((segment, index) => {
            const url = `/${pathSegments.slice(0, index + 1).join("/")}`;
            const isLast = index === pathSegments.length - 1;

            // Handle dynamic naming for nested paths
            const label =
                pathMap[segment] ||
                segment.replace(/-/g, " ").replace(/^\w/, (c) => c.toUpperCase());

            return { label, url, isLast };
        });

        setBreadcrumbs(crumbs);
    }, [location.pathname]);

    return (
        <BreadcrumbContainer aria-label="breadcrumb">
            <Crumb href="/">Home</Crumb>

            {breadcrumbs.map((crumb, index) => (
                <React.Fragment key={index}>
                    <Separator>›</Separator>
                    <Crumb href={crumb.isLast ? undefined : crumb.url} active={crumb.isLast}>
                        {crumb.label}
                    </Crumb>
                </React.Fragment>
            ))}
        </BreadcrumbContainer>
    );
}
